import type { FunctionComponent, PropsWithChildren } from 'react';

import { withForwardedEnv } from '../../config/forwardedEnv';
import FlowParameters from './FlowParameters';

type ConsentFormProps = PropsWithChildren<{ action?: string }>;

const ConsentForm: FunctionComponent<ConsentFormProps> = ({
  children,
  action = '/authorize/resume',
}) => {
  return (
    <form action={withForwardedEnv(action)} method="post">
      <FlowParameters />
      {children}
    </form>
  );
};
export default ConsentForm;
